module.exports = __webpack_public_path__ + "img/image 9.d5b4ffa7.png";